import { ComponentFactoryResolver, Injectable, Type } from '@angular/core';
import { DeviceGroupingComponent } from '../device-grouping/device-grouping.component';
import { DeviceInputComponent } from './device-input.component';
import { DynamicElementListInputComponent } from './dynamic-element-list-input/dynamic-element-list-input.component';
import { FaultSensorComponent } from './fault-sensor/fault-sensor.component';
import { NumberSensorInputComponent } from './number-sensor-input/number-sensor-input.component';
import { SliderNumberSensorInputComponent } from './slider-number-sensor-input/slider-number-sensor-input.component';
import { TextNumberSensorInputComponent } from './text-number-sensor-input/text-number-sensor-input.component';
import { SecondsSensorInputComponent } from './seconds-sensor-input/seconds-sensor-input.component';
import { SelectListInputComponent } from './select-list-input/select-list-input.component';
import { StaticElementListInputComponent } from './static-element-list-input/static-element-list-input.component';
import { SwitchSensorComponent } from './switch-sensor/switch-sensor.component';
import { TimeDateSensorInputComponent } from './time-date-sensor-input/time-date-sensor-input.component';
import { DynamicCalendarComponent } from '../dynamic-calendar/dynamic-calendar.component';
import { EmptyComponent } from '../empty-component/empty.component';
import { InputSectionComponent } from '../input-section/input-section.component';
import { RealTimeSensorInputComponent } from './real-time-sensor-input/real-time-sensor-input.component';
import { HoverInfoComponent } from '@caslink/common-client/ng-app/hoverInfo/HoverInfoComponent';


/** This NEEDS to be extracted to an external package for reuse */

interface AugmentedType extends Type<any> {
    $name?: string;
}

@Injectable({
    providedIn: 'root'
})
export class DynamicComponentService {
    private readonly factories = new Map<string, AugmentedType>([
        [DeviceInputComponent.$name.toLowerCase(), DeviceInputComponent],
        [DeviceGroupingComponent.$name.toLowerCase(), DeviceGroupingComponent],
        [DynamicCalendarComponent.$name.toLowerCase(), DynamicCalendarComponent],
        [DynamicElementListInputComponent.$name.toLowerCase(), DynamicElementListInputComponent],
        [EmptyComponent.$name.toLowerCase(), EmptyComponent],
        [InputSectionComponent.$name.toLowerCase(), InputSectionComponent],
        [NumberSensorInputComponent.$name.toLowerCase(), NumberSensorInputComponent],
        [RealTimeSensorInputComponent.$name.toLowerCase(), RealTimeSensorInputComponent],
        [SecondsSensorInputComponent.$name.toLowerCase(), SecondsSensorInputComponent],
        [SelectListInputComponent.$name.toLowerCase(), SelectListInputComponent],
        [SliderNumberSensorInputComponent.$name.toLowerCase(), SliderNumberSensorInputComponent],
        [StaticElementListInputComponent.$name.toLowerCase(), StaticElementListInputComponent],
        [SwitchSensorComponent.$name.toLowerCase(), SwitchSensorComponent],
        [TextNumberSensorInputComponent.$name.toLowerCase(), TextNumberSensorInputComponent],
        [TimeDateSensorInputComponent.$name.toLowerCase(), TimeDateSensorInputComponent],
        [FaultSensorComponent.$name.toLowerCase(), FaultSensorComponent],
        [HoverInfoComponent.$name.toLowerCase(), HoverInfoComponent]
    ]);

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver
    ) {
    }

    public resolveComponent(name: string) {
        name = name.toLowerCase();
        const factoryClass = this.getFactoryClassIfExist(name);

        if (!factoryClass) {
            throw new Error(`${name} must be implemented as an Angular component`);
        }

        return this.componentFactoryResolver.resolveComponentFactory(factoryClass);
    }

    public getFactoryClassIfExist(name: string) {
        name = name.toLowerCase();
        return this.factories.get(name);
    }
}
